/*============================================================
   REACT DEPENDENCIES
============================================================*/
import { useState, useEffect } from "react";

/*============================================================
   REDUX DEPENDENCIES
============================================================*/
import { useDispatch, useSelector } from "react-redux";

import { FormControl } from "@mui/material";
import Grid from "@mui/material/Grid2";
import Typography from "@mui/material/Typography";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormHelperText from "@mui/material/FormHelperText";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import Stack from "@mui/material/Stack";
import TextareaAutosize from "@mui/material/TextareaAutosize";

import GridSectionHeader from "../../../widgets/GridSectionHeader";

import { valudateTextfield2 } from "../../../../utils/fieldValidator.js";
import { MAX_LENGTH_TEXTAREA } from "../../../../utils/constants.js";

//DATA SLICE - REDUCER
import { updateCKACKR } from "../../../../states/slcCkaCkr.js";

var isFinanceQualifiedError = "";
var financeEducationInstituteError = "";

//TRUE - WHEN COMPONENT IS VALID
var validCKAFinancial = false;

export function getCKAFinancialValidity() {
  return validCKAFinancial;
}

export default function SectionCKAFinancial({ setEnableNext }) {
  const ckackr = useSelector((state) => state.ckackr);

  const [isFinanceQualified, setIsFinanceQualified] = useState(ckackr.isFinanceQualified);
  const [financeEducationInstitute, setFinanceEducationInstitute] = useState(ckackr.financeEducationInstitute);

  const dispatch = useDispatch();

  useEffect(() => {
    const data = {
      isFinanceQualified: isFinanceQualified,
      financeEducationInstitute: financeEducationInstitute,
    };
    updateRedux("professional", data, updateCKACKR);
  }, [isFinanceQualified, financeEducationInstitute]);

  function updateRedux(fieldName, fieldValue, reducer) {
    const action = {
      type: fieldName,
      payload: fieldValue,
    };
    dispatch(reducer(action));
  }

  function handleChange(e, id) {
    let input_data = {
      event: e,
      fieldName: "",
      fieldVariable: "",
      isMandatory: false,
    };

    input_data.e = e;

    let type = "";
    let name = "";

    id = e.target.id.toLowerCase();

    //RADIOBOX
    if (id === "") {
      type = e.target.type;
      name = e.target.name;
      validateRadiobox(e, type, name);
    }

    //TEXTFIELDS
    validateTextfield(id, input_data);

    calculateValidity();
  }

  function validateRadiobox(e, type, name) {
    if (type === "radio" && name === "isFinanceQualified") {
      setIsFinanceQualified(e.target.value);
      // updateRedux("isEducationQualified", e.target.checked, updateSummary);
      isFinanceQualifiedError = "";
    }
  }

  function validateTextfield(id, input_data) {
    if (id === "financeeducationinstitute") {
      input_data.fieldName = "Financial institute description";
      input_data.fieldVariable = financeEducationInstitute;
      input_data.fieldLength = MAX_LENGTH_TEXTAREA;
      input_data.isMandatory = true;
      const result = valudateTextfield2(input_data);

      if (result.errorMessage === "") {
        setFinanceEducationInstitute(result.value);
        financeEducationInstituteError = "";
        //updateRedux("networthImpactDesc", result.value, updateSummary);
      } else financeEducationInstituteError = "Financial institute description is required";
    }
  }

  function calculateValidity() {
    validCKAFinancial = false;

    if (isFinanceQualifiedError.length !== 0 || financeEducationInstituteError.length !== 0) {
      validCKAFinancial = false;
      setEnableNext(false);
      return;
    }

    validCKAFinancial = true;
    setEnableNext(true);
  }

  return (
    <>
      <Grid container spacing={2}>
        <GridSectionHeader
          sectionName="Professional Qualification"
          sx={{
            p: 1,
            pl: 1.8,
            mt: 0,
            mb: 1,
            fontSize: 18,
            fontWeight: "bold",
            color: "#FFFFFF", //WHITE
            // color: "#000000", //BLACK
            // backgroundColor: "#d9d9d9",
            backgroundColor: "#10B981",
          }}
        />

        <Typography variant="body1">
          2. Do you posses any professional finance related qualification? (E.g AFP, AWP, CFP, AFC, ChFC, ACCA, CLU,
          CFA, CAIA, CPA/CA, FRM, CISI, CFTe, CMFAS M6A/MBA/M9A)
        </Typography>
      </Grid>

      <RadioGroup row name="isFinanceQualified" defaultValue="" value={isFinanceQualified} onChange={handleChange}>
        <FormControl>
          <Stack direction="row">
            <FormControlLabel id="isFinanceQualifiedYes" control={<Radio />} label="Yes" value="Yes" />

            <FormControlLabel id="isFinanceQualifiedNo" control={<Radio />} label="No" value="No" />
          </Stack>
        </FormControl>
      </RadioGroup>

      {/*==============================
        FINANCE EDUCATION INSTITUTE DETAILS
      ==============================*/}
      {isFinanceQualified === "Yes" && (
        <Grid size={12}>
          <Typography variant="body1">
            Please specify fullname of qualification(s), Educational Institution(s) in which the qualification(s) were
            obtained.
          </Typography>

          <TextareaAutosize
            id="financeEducationInstitute"
            placeholder="Type here..."
            style={{ width: "100%" }}
            minRows={5}
            onChange={handleChange}
            defaultValue={financeEducationInstitute}
          />
          {financeEducationInstituteError && (
            <FormHelperText error={financeEducationInstituteError}>{financeEducationInstituteError}</FormHelperText>
          )}
        </Grid>
      )}
    </>
  );
}
